import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Darren Dunlap',
    quote: 'I recently visited Washington, D.C., and needed a mobility scooter to help me navigate the city. I was so impressed with the service provided by them. They delivered the scooter right to my hotel and made the rental process so easy.',
    initials: 'DD',
    color: 'bg-blue-100 text-blue-700'
  }, {
    name: 'Lily Davids',
    quote: 'The customer service was exceptional, and the rental process was straightforward. The team even helped me choose the right wheelchair for my needs. I would highly recommend this company to anyone looking for mobility equipment rentals',
    initials: 'LD',
    color: 'bg-rose-100 text-rose-700'
  }, {
    name: 'Will Turner',
    quote: "I've used WheelAround Rentals multiple times during my business trips. The equipment is always top-notch, and the team is so helpful. They've even delivered scooters to me at different hotels in the area, making it so easy to get around.",
    initials: 'WT',
    color: 'bg-emerald-100 text-emerald-700'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-466">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-467">
        <div className="text-center mb-16" data-id="element-468">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex items-center justify-center gap-3 mb-4" data-id="element-469">
            <div className="h-[2px] w-8 bg-brand-red" data-id="element-470"></div>
            <span className="text-brand-red font-bold tracking-wider text-sm uppercase" data-id="element-471">
              Testimonials
            </span>
            <div className="h-[2px] w-8 bg-brand-red" data-id="element-472"></div>
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-brand-navy mb-6" data-id="element-473">
            What Our Customers Say
          </motion.h2>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-474">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={cardVariants} className="bg-brand-gray rounded-3xl p-8 shadow-sm relative" data-id="element-475">
              <QuoteIcon className="absolute top-6 right-6 w-12 h-12 text-brand-navy/5" data-id="element-476" />

              <div className="flex gap-1 mb-6" data-id="element-477">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-5 h-5 text-amber-400 fill-amber-400" data-id="element-478" />)}
              </div>

              <p className="text-brand-charcoal/80 text-lg leading-relaxed mb-8 relative z-10" data-id="element-479">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-480">
                <div className={`w-12 h-12 rounded-full ${testimonial.color} flex items-center justify-center font-bold text-lg`} data-id="element-481">
                  {testimonial.initials}
                </div>
                <div data-id="element-482">
                  <h4 className="font-bold text-brand-navy" data-id="element-483">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-brand-charcoal/50" data-id="element-484">
                    Verified Customer
                  </p>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}